import { render, staticRenderFns } from "./CollapsableSegment.vue?vue&type=template&id=7c51ca78&"
import script from "./CollapsableSegment.vue?vue&type=script&lang=js&"
export * from "./CollapsableSegment.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableSegment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports